// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Next Station Panel Styles */

.next-station-panel-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    z-index: 9998;
    animation: fadeInPanel 0.3s ease;
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
}

.next-station-panel {
    width: 420px;
    max-width: 90vw;
    height: 100%;
    border-radius: 0;
    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    animation: slideInFromRight 0.3s ease;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    overflow: hidden;
}

@keyframes fadeInPanel {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes slideInFromRight {
    from {
        opacity: 0;
        transform: translateX(100%);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

/* Header */
.next-panel-header {
    padding: 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
}

.panel-title-section {
    display: flex;
    align-items: center;
    gap: 12px;
}

.panel-icon {
    font-size: 24px;
    color: #ff4444;
}

.panel-title {
    font-size: 20px;
    font-weight: 700;
    margin: 0;
}

.close-panel-btn {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    transition: all 0.2s ease;
    opacity: 0.7;
}

.close-panel-btn:hover {
    opacity: 1;
    background: rgba(255, 255, 255, 0.1);
    transform: scale(1.1);
}

/* Search Section */
.search-section {
    padding: 0 24px 20px 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    flex-shrink: 0;
}

.search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.search-icon {
    position: absolute;
    left: 12px;
    font-size: 14px;
    opacity: 0.5;
    z-index: 1;
}

.search-input {
    width: 100%;
    padding: 12px 16px 12px 40px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 25px;
    font-size: 14px;
    background: transparent;
    transition: all 0.2s ease;
}

.search-input:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.05);
}

.search-input::placeholder {
    opacity: 0.5;
}

/* Current Station Info */
.current-station-info {
    margin: 20px 24px;
    padding: 16px;
    border-radius: 12px;
    border-left: 4px solid #ff4444;
    flex-shrink: 0;
}

.current-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #ff4444;
    margin-bottom: 12px;
}

.current-badge .live-icon {
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
}

.current-station-details {
    display: flex;
    align-items: center;
    gap: 12px;
}

.current-station-image {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    object-fit: cover;
    border: 2px solid rgba(255, 255, 255, 0.1);
    flex-shrink: 0;
}

.current-station-text {
    flex: 1 1;
    min-width: 0;
}

.current-station-title {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 4px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.current-station-desc {
    font-size: 12px;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

/* Stations List Section */
.stations-list-section {
    flex: 1 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.stations-loading,
.stations-error,
.no-stations {
    padding: 60px 24px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    justify-content: center;
    flex: 1 1;
}

.loading-spinner-panel {
    width: 40px;
    height: 40px;
    border: 3px solid rgba(255, 255, 255, 0.1);
    border-top: 3px solid #ffffff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.error-icon,
.no-stations-icon {
    font-size: 48px;
    opacity: 0.3;
}

.retry-btn-panel {
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s ease;
}

.retry-btn-panel:hover {
    transform: translateY(-2px);
}

/* Stations List */
.stations-list {
    flex: 1 1;
    overflow-y: auto;
    padding: 20px 24px;
}

.station-item {
    display: flex;
    gap: 12px;
    padding: 12px;
    border-radius: 12px;
    margin-bottom: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid transparent;
    position: relative;
}

.station-item:hover:not(.locked):not(.unavailable) {
    border-color: rgba(255, 255, 255, 0.1);
    transform: translateX(4px);
    background: rgba(255, 255, 255, 0.02);
}

.station-item.locked {
    cursor: not-allowed;
    opacity: 0.6;
}

.station-item.unavailable {
    cursor: not-allowed;
    opacity: 0.5;
}

.station-item-image {
    position: relative;
    flex-shrink: 0;
}

.station-thumbnail {
    width: 60px;
    height: 60px;
    border-radius: 8px;
    object-fit: cover;
    border: 2px solid rgba(255, 255, 255, 0.1);
}

.station-status-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 8px;
    opacity: 0;
    transition: all 0.2s ease;
}

.station-item:hover .station-status-overlay {
    opacity: 1;
}

.station-item.locked .station-status-overlay,
.station-item.unavailable .station-status-overlay {
    opacity: 1;
}

.status-icon {
    font-size: 16px;
    color: white;
}

.locked-icon {
    color: #ffd700;
}

.play-icon {
    color: #4ade80;
}

.playing-icon {
    color: #ff4444;
}

.unavailable-badge {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    padding: 2px 6px;
}

.unavailable-badge span {
    font-size: 10px;
    font-weight: 600;
    color: white;
}

.playing-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
}

.audio-bars {
    display: flex;
    align-items: end;
    gap: 2px;
}

.bar {
    width: 3px;
    background: #ff4444;
    border-radius: 1px;
    animation: audioWave 1.5s ease-in-out infinite alternate;
}

.bar1 { height: 8px; animation-delay: 0s; }
.bar2 { height: 12px; animation-delay: 0.1s; }
.bar3 { height: 6px; animation-delay: 0.2s; }

@keyframes audioWave {
    0% { height: 2px; }
    100% { opacity: 1; }
}

.live-badge-small {
    position: absolute;
    bottom: 4px;
    right: 4px;
    background: #ff4444;
    border-radius: 50%;
    padding: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.live-icon-small {
    color: white;
    font-size: 8px;
}

.station-item-content {
    flex: 1 1;
    min-width: 0;
}

.station-item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
}

.station-item-title {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1;
}

.station-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    opacity: 0;
    transition: all 0.2s ease;
}

.station-item:hover .station-actions {
    opacity: 1;
}

.action-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 50%;
    transition: all 0.2s ease;
    font-size: 12px;
    opacity: 0.7;
}

.action-btn:hover {
    opacity: 1;
    background: rgba(255, 255, 255, 0.1);
    transform: scale(1.1);
}

.next-arrow {
    font-size: 12px;
    opacity: 0.5;
}

.station-item-desc {
    font-size: 12px;
    margin: 0 0 8px 0;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.station-item-meta {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 11px;
}

.station-type {
    font-weight: 500;
}

.premium-badge {
    display: flex;
    align-items: center;
    gap: 4px;
    background: rgba(255, 215, 0, 0.2);
    color: #ffd700;
    padding: 2px 6px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 10px;
    border: 1px solid rgba(255, 215, 0, 0.3);
}

.unavailable-badge-text {
    background: rgba(255, 68, 68, 0.2);
    color: #ff6b6b;
    padding: 2px 6px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 10px;
    border: 1px solid rgba(255, 68, 68, 0.3);
}

/* Footer */
.next-panel-footer {
    padding: 16px 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    flex-shrink: 0;
    text-align: center;
}

.footer-info {
    font-size: 12px;
}

/* Scrollbar Styling */
.stations-list::-webkit-scrollbar {
    width: 6px;
}

.stations-list::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
}

.stations-list::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
}

.stations-list::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
}

/* Responsive Design */
@media (max-width: 768px) {
    .next-station-panel {
        width: 100%;
        max-width: 100%;
    }
    
    .next-panel-header {
        padding: 20px;
    }
    
    .search-section {
        padding: 0 20px 16px 20px;
    }
    
    .current-station-info {
        margin: 16px 20px;
    }
    
    .stations-list {
        padding: 16px 20px;
    }
    
    .station-thumbnail {
        width: 50px;
        height: 50px;
    }
    
    .next-panel-footer {
        padding: 12px 20px;
    }
}

@media (max-width: 480px) {
    .panel-title {
        font-size: 18px;
    }
    
    .station-item {
        gap: 10px;
        padding: 10px;
    }
    
    .station-thumbnail {
        width: 45px;
        height: 45px;
    }
    
    .station-item-title {
        font-size: 13px;
    }
    
    .station-item-desc {
        font-size: 11px;
    }
    
    .current-station-image {
        width: 45px;
        height: 45px;
    }
    
    .current-station-title {
        font-size: 14px;
    }
}

/* Theme Integration */
.next-station-panel.theme-bg-color {
    /* Theme background will be applied by parent component */
}

.theme-text-color {
    /* Theme text color will be applied by parent component */
}

.theme-button-bg-color {
    /* Theme button background will be applied by parent component */
}

.theme-button-text-color {
    /* Theme button text color will be applied by parent component */
}

.theme-bg-color-secondary {
    /* Secondary background color will be applied by parent component */
}

/* Dark theme adjustments */
.next-station-panel[data-theme="dark"] {
    background: rgba(20, 20, 20, 0.98);
    border-color: rgba(255, 255, 255, 0.1);
}

/* Light theme adjustments */
.next-station-panel[data-theme="light"] {
    background: rgba(255, 255, 255, 0.98);
    border-color: rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/Pages/Music/RadioStation/Components/Styles/NextStationPanel.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,WAAW;AACX;IACI,aAAa;IACb,iDAAiD;IACjD,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,kDAAkD;IAClD,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,YAAY,EAAE;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;IAGI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;;IAEI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,kBAAkB;AAClB;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA,QAAQ,WAAW,EAAE,mBAAmB,EAAE;AAC1C,QAAQ,YAAY,EAAE,qBAAqB,EAAE;AAC7C,QAAQ,WAAW,EAAE,qBAAqB,EAAE;;AAE5C;IACI,KAAK,WAAW,EAAE;IAClB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kCAAkC;IAClC,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,wCAAwC;AAC5C;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA,sBAAsB;AACtB;IACI;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,sBAAsB;AACtB;IACI,yDAAyD;AAC7D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,mEAAmE;AACvE;;AAEA,2BAA2B;AAC3B;IACI,kCAAkC;IAClC,sCAAsC;AAC1C;;AAEA,4BAA4B;AAC5B;IACI,qCAAqC;IACrC,gCAAgC;AACpC","sourcesContent":["/* Next Station Panel Styles */\n\n.next-station-panel-overlay {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.6);\n    backdrop-filter: blur(4px);\n    z-index: 9998;\n    animation: fadeInPanel 0.3s ease;\n    display: flex;\n    justify-content: flex-end;\n    align-items: stretch;\n}\n\n.next-station-panel {\n    width: 420px;\n    max-width: 90vw;\n    height: 100%;\n    border-radius: 0;\n    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.3);\n    display: flex;\n    flex-direction: column;\n    animation: slideInFromRight 0.3s ease;\n    border-left: 1px solid rgba(255, 255, 255, 0.1);\n    overflow: hidden;\n}\n\n@keyframes fadeInPanel {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes slideInFromRight {\n    from {\n        opacity: 0;\n        transform: translateX(100%);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n/* Header */\n.next-panel-header {\n    padding: 24px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-shrink: 0;\n}\n\n.panel-title-section {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.panel-icon {\n    font-size: 24px;\n    color: #ff4444;\n}\n\n.panel-title {\n    font-size: 20px;\n    font-weight: 700;\n    margin: 0;\n}\n\n.close-panel-btn {\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n    opacity: 0.7;\n}\n\n.close-panel-btn:hover {\n    opacity: 1;\n    background: rgba(255, 255, 255, 0.1);\n    transform: scale(1.1);\n}\n\n/* Search Section */\n.search-section {\n    padding: 0 24px 20px 24px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    flex-shrink: 0;\n}\n\n.search-input-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.search-icon {\n    position: absolute;\n    left: 12px;\n    font-size: 14px;\n    opacity: 0.5;\n    z-index: 1;\n}\n\n.search-input {\n    width: 100%;\n    padding: 12px 16px 12px 40px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 25px;\n    font-size: 14px;\n    background: transparent;\n    transition: all 0.2s ease;\n}\n\n.search-input:focus {\n    outline: none;\n    border-color: rgba(255, 255, 255, 0.3);\n    background: rgba(255, 255, 255, 0.05);\n}\n\n.search-input::placeholder {\n    opacity: 0.5;\n}\n\n/* Current Station Info */\n.current-station-info {\n    margin: 20px 24px;\n    padding: 16px;\n    border-radius: 12px;\n    border-left: 4px solid #ff4444;\n    flex-shrink: 0;\n}\n\n.current-badge {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: #ff4444;\n    margin-bottom: 12px;\n}\n\n.current-badge .live-icon {\n    animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.5; }\n}\n\n.current-station-details {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.current-station-image {\n    width: 50px;\n    height: 50px;\n    border-radius: 8px;\n    object-fit: cover;\n    border: 2px solid rgba(255, 255, 255, 0.1);\n    flex-shrink: 0;\n}\n\n.current-station-text {\n    flex: 1;\n    min-width: 0;\n}\n\n.current-station-title {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0 0 4px 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.current-station-desc {\n    font-size: 12px;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n/* Stations List Section */\n.stations-list-section {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.stations-loading,\n.stations-error,\n.no-stations {\n    padding: 60px 24px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    justify-content: center;\n    flex: 1;\n}\n\n.loading-spinner-panel {\n    width: 40px;\n    height: 40px;\n    border: 3px solid rgba(255, 255, 255, 0.1);\n    border-top: 3px solid #ffffff;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.error-icon,\n.no-stations-icon {\n    font-size: 48px;\n    opacity: 0.3;\n}\n\n.retry-btn-panel {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: all 0.2s ease;\n}\n\n.retry-btn-panel:hover {\n    transform: translateY(-2px);\n}\n\n/* Stations List */\n.stations-list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 20px 24px;\n}\n\n.station-item {\n    display: flex;\n    gap: 12px;\n    padding: 12px;\n    border-radius: 12px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 1px solid transparent;\n    position: relative;\n}\n\n.station-item:hover:not(.locked):not(.unavailable) {\n    border-color: rgba(255, 255, 255, 0.1);\n    transform: translateX(4px);\n    background: rgba(255, 255, 255, 0.02);\n}\n\n.station-item.locked {\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n.station-item.unavailable {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.station-item-image {\n    position: relative;\n    flex-shrink: 0;\n}\n\n.station-thumbnail {\n    width: 60px;\n    height: 60px;\n    border-radius: 8px;\n    object-fit: cover;\n    border: 2px solid rgba(255, 255, 255, 0.1);\n}\n\n.station-status-overlay {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.6);\n    border-radius: 8px;\n    opacity: 0;\n    transition: all 0.2s ease;\n}\n\n.station-item:hover .station-status-overlay {\n    opacity: 1;\n}\n\n.station-item.locked .station-status-overlay,\n.station-item.unavailable .station-status-overlay {\n    opacity: 1;\n}\n\n.status-icon {\n    font-size: 16px;\n    color: white;\n}\n\n.locked-icon {\n    color: #ffd700;\n}\n\n.play-icon {\n    color: #4ade80;\n}\n\n.playing-icon {\n    color: #ff4444;\n}\n\n.unavailable-badge {\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 4px;\n    padding: 2px 6px;\n}\n\n.unavailable-badge span {\n    font-size: 10px;\n    font-weight: 600;\n    color: white;\n}\n\n.playing-indicator {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.audio-bars {\n    display: flex;\n    align-items: end;\n    gap: 2px;\n}\n\n.bar {\n    width: 3px;\n    background: #ff4444;\n    border-radius: 1px;\n    animation: audioWave 1.5s ease-in-out infinite alternate;\n}\n\n.bar1 { height: 8px; animation-delay: 0s; }\n.bar2 { height: 12px; animation-delay: 0.1s; }\n.bar3 { height: 6px; animation-delay: 0.2s; }\n\n@keyframes audioWave {\n    0% { height: 2px; }\n    100% { opacity: 1; }\n}\n\n.live-badge-small {\n    position: absolute;\n    bottom: 4px;\n    right: 4px;\n    background: #ff4444;\n    border-radius: 50%;\n    padding: 3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.live-icon-small {\n    color: white;\n    font-size: 8px;\n}\n\n.station-item-content {\n    flex: 1;\n    min-width: 0;\n}\n\n.station-item-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 6px;\n}\n\n.station-item-title {\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n}\n\n.station-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    opacity: 0;\n    transition: all 0.2s ease;\n}\n\n.station-item:hover .station-actions {\n    opacity: 1;\n}\n\n.action-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 50%;\n    transition: all 0.2s ease;\n    font-size: 12px;\n    opacity: 0.7;\n}\n\n.action-btn:hover {\n    opacity: 1;\n    background: rgba(255, 255, 255, 0.1);\n    transform: scale(1.1);\n}\n\n.next-arrow {\n    font-size: 12px;\n    opacity: 0.5;\n}\n\n.station-item-desc {\n    font-size: 12px;\n    margin: 0 0 8px 0;\n    line-height: 1.3;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.station-item-meta {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 11px;\n}\n\n.station-type {\n    font-weight: 500;\n}\n\n.premium-badge {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    background: rgba(255, 215, 0, 0.2);\n    color: #ffd700;\n    padding: 2px 6px;\n    border-radius: 10px;\n    font-weight: 600;\n    font-size: 10px;\n    border: 1px solid rgba(255, 215, 0, 0.3);\n}\n\n.unavailable-badge-text {\n    background: rgba(255, 68, 68, 0.2);\n    color: #ff6b6b;\n    padding: 2px 6px;\n    border-radius: 10px;\n    font-weight: 600;\n    font-size: 10px;\n    border: 1px solid rgba(255, 68, 68, 0.3);\n}\n\n/* Footer */\n.next-panel-footer {\n    padding: 16px 24px;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n    flex-shrink: 0;\n    text-align: center;\n}\n\n.footer-info {\n    font-size: 12px;\n}\n\n/* Scrollbar Styling */\n.stations-list::-webkit-scrollbar {\n    width: 6px;\n}\n\n.stations-list::-webkit-scrollbar-track {\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 3px;\n}\n\n.stations-list::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.3);\n    border-radius: 3px;\n}\n\n.stations-list::-webkit-scrollbar-thumb:hover {\n    background: rgba(255, 255, 255, 0.5);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .next-station-panel {\n        width: 100%;\n        max-width: 100%;\n    }\n    \n    .next-panel-header {\n        padding: 20px;\n    }\n    \n    .search-section {\n        padding: 0 20px 16px 20px;\n    }\n    \n    .current-station-info {\n        margin: 16px 20px;\n    }\n    \n    .stations-list {\n        padding: 16px 20px;\n    }\n    \n    .station-thumbnail {\n        width: 50px;\n        height: 50px;\n    }\n    \n    .next-panel-footer {\n        padding: 12px 20px;\n    }\n}\n\n@media (max-width: 480px) {\n    .panel-title {\n        font-size: 18px;\n    }\n    \n    .station-item {\n        gap: 10px;\n        padding: 10px;\n    }\n    \n    .station-thumbnail {\n        width: 45px;\n        height: 45px;\n    }\n    \n    .station-item-title {\n        font-size: 13px;\n    }\n    \n    .station-item-desc {\n        font-size: 11px;\n    }\n    \n    .current-station-image {\n        width: 45px;\n        height: 45px;\n    }\n    \n    .current-station-title {\n        font-size: 14px;\n    }\n}\n\n/* Theme Integration */\n.next-station-panel.theme-bg-color {\n    /* Theme background will be applied by parent component */\n}\n\n.theme-text-color {\n    /* Theme text color will be applied by parent component */\n}\n\n.theme-button-bg-color {\n    /* Theme button background will be applied by parent component */\n}\n\n.theme-button-text-color {\n    /* Theme button text color will be applied by parent component */\n}\n\n.theme-bg-color-secondary {\n    /* Secondary background color will be applied by parent component */\n}\n\n/* Dark theme adjustments */\n.next-station-panel[data-theme=\"dark\"] {\n    background: rgba(20, 20, 20, 0.98);\n    border-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Light theme adjustments */\n.next-station-panel[data-theme=\"light\"] {\n    background: rgba(255, 255, 255, 0.98);\n    border-color: rgba(0, 0, 0, 0.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
